import { TEnvFeatureFlag } from "@/services/feature-flags/feature-flags.types";
import { isOperator } from "@/utils/env-feature-flag/env-feature-flag-user-bypass";

export const newSectionManagementFeatureFlag: TEnvFeatureFlag = {
  name: "VITE_ENABLE_NEW_SECTION_MANAGEMENT",
  userBypass: isOperator,
};

export const siteDefaultProgramFeatureFlag: TEnvFeatureFlag = {
  name: "VITE_ENABLE_SITE_DEFAULT_PROGRAM",
  userBypass: isOperator,
};
